import OrganizationService from '../services/organization.service';
import { DepartmentService } from '../services/department.service';
import gotoUrlTemplates, { QuickSearchResult, SearchResultType } from '../components/quick-search-overlay/quick-search-overlay.model';

/**
 * Helper function to populate go-to URLs for quick search results.
 * This function enriches search results with routing information and query parameters.
 *
 * @param quickSearchResults - Array of search results to populate with URLs
 * @param organizationService - Service to fetch organization data
 * @param departmentService - Service to fetch department data
 */
export async function populateQuickSearchGoToUrls(
  quickSearchResults: QuickSearchResult[],
  organizationService: OrganizationService,
  departmentService: DepartmentService
): Promise<void> {
  const allOrganizations = await organizationService.getAndStoreOrganizations();
  const allDepartments = await departmentService.getAndStoreDepartments();

  quickSearchResults.forEach(quickSearchResult => {
    quickSearchResult.quickSearchResponses.forEach(item => {
      if (quickSearchResult.searchResultType !== SearchResultType.Organization) {
        item.organizationName = allOrganizations?.find(o => o.id === item.organizationId)?.name ?? null;
      }
      if (quickSearchResult.searchResultType !== SearchResultType.Department) {
        item.departmentName = allDepartments?.find(o => o.id === item.departmentId)?.name ?? null;
      }

      item.routerLink = gotoUrlTemplates.get(quickSearchResult.searchResultType)?.routerLink ?? null;

      switch (quickSearchResult.searchResultType) {
        case SearchResultType.Organization:
          item.queryParameters = {
            organizationId: item.organizationId,
          };
          if (item.name) {
            item.mapQueryParameters = {
              mapSearchInputType: 'address',
              query: item.name,
            };
          }
          break;
        case SearchResultType.Department:
          item.queryParameters = {
            organizationId: item.organizationId,
            departmentId: item.departmentId,
          };
          if (item.address) {
            item.mapQueryParameters = {
              mapSearchInputType: 'address',
              query: item.address,
            };
          }
          break;
        case SearchResultType.ChargingStationLocation:
          item.queryParameters = {
            chargingStationLocationIdentifier: item.identifier,
          };
          item.mapQueryParameters = {
            mapSearchInputType: 'location',
            query: item.identifier,
          };
          break;
        case SearchResultType.PricePolicy:
          item.queryParameters = {
            pricePolicyId: item.id,
          };
          break;
        case SearchResultType.IdTag:
          item.queryParameters = {
            printedId: item.description,
            includeInactive: true,
          };
          break;
        case SearchResultType.ChargingUser:
          item.queryParameters = {
            chargingUserId: item.id,
          };
          if (item.description2) {
            item.mapQueryParameters = {
              mapSearchInputType: 'mokUserNumber',
              query: item.description2,
            };
          }
          break;
      }
    });
  });
}
